exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg-icon[data-v-54eba400]{width:3.75rem;height:2rem;vertical-align:-.15em;fill:currentColor;overflow:hidden}.svg-external-icon[data-v-54eba400]{background-color:currentColor;-webkit-mask-size:cover!important;mask-size:cover!important;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54eba400","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/SvgIcon.vue
// module id = LOgy
// module chunks = 44